<template>
  <form @submit.prevent="onSubmit">
    <div class="row mb-3">
      <label for="firstName" class="col-md-4 col-lg-3 col-form-label">Имя</label>
      <div class="col-md-8 col-lg-9">
        <input v-model="local.firstName" name="firstName" type="text" class="form-control" id="firstName" value="">
      </div>
    </div>

    <div class="row mb-3">
      <label for="lastName" class="col-md-4 col-lg-3 col-form-label">Фамилия</label>
      <div class="col-md-8 col-lg-9">
        <input v-model="local.lastName" name="lastName" type="text" class="form-control" id="lastName" value="">
      </div>
    </div>

    <div class="row mb-3">
      <label for="phone" class="col-md-4 col-lg-3 col-form-label">Телефон</label>
      <div class="col-md-8 col-lg-9">
        <input v-model="local.phone"  v-mask="'+7 (###) ###-##-##'" name="phone" type="text" class="form-control" id="phone" value="">
      </div>
    </div>

    <TelegamSubscribe />

    <div v-if="error" class="invalid-feedback" style="display: block" v-html="error"></div>
    <div v-if="success" class="text-center small" style="display: block; color: green" v-html="success"></div>
    <br>
    <div class="text-center">
      <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <button type="submit" class="btn btn-primary" :disabled="loading">Сохранить</button>
    </div>
  </form>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { usePersonal } from '@/features/personal/composables/usePersonal';
import {reactive, ref} from "vue";
import TelegamSubscribe from "@/features/personal/components/TelegamSubscribe.vue";

const route = useRoute();
const { setUserInfo, currentUser } = usePersonal();
const error = ref('');
const success = ref(false);
const loading = ref(false);
const local = reactive({
  firstName: currentUser.value?.firstName ?? null,
  lastName: currentUser.value?.lastName ?? null,
  phone: currentUser.value?.phone ?? null
});

async function onSubmit() {
  loading.value = true;
  error.value = '';
  success.value = '';
  const payload = local;
  if (payload?.phone.length) {
    payload.phone = normalizePhone(payload.phone);
  }
  try {
    await setUserInfo(payload);
    success.value = "Данные изменены";
  } catch (e) {
    error.value = "Произошла ошибка";
    if (e?.details) {
      e.details.forEach(function (err)  {
        if (err.field === 'phone') {
          error.value = 'Проверьте правильность телефона';
        }
      });
    }
  } finally {
    loading.value = false;
  }
}

function normalizePhone(phone) {
  return phone.replace(/\D/g, '');
}
</script>

<style scoped>

</style>